import { colors } from 'style/theme';

export const defaultTheme = (theme) => {
  return {
    ...theme,
    colors: {
      ...theme.colors,
      primary: colors.silverGray, // selected option text
      neutral0: colors.white, // menu bg
      primary50: colors.galleryGray, // bg mousedown selected option,
      primary25: colors.galleryGray // bg hovered option
    }
  };
};

// ================== Dark variant ================== //

const darkStyles = (disabled, newInputStyle) => ({
  container: (base) => ({
    ...base,
    paddingTop: '5px'
  }),
  input: () => ({
    height: '22px',
    color: colors.black,
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    textIndent: 0,
    marginLeft: '2px'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '16px',
      color: colors.black
    };
  },
  control: (base) => ({
    ...base,
    borderRadius: 0,
    background: 'transparent',
    border: '0',
    borderBottom: disabled || newInputStyle ? 'none' : `1px solid ${colors.black}`,
    opacity: disabled ? 0.7 : 1,
    boxShadow: '0',
    '&:hover': {
      border: '0',
      borderBottom: newInputStyle ? 'none' : `1px solid ${colors.black}`
    },
    outline: 'none',
    minHeight: '22px',
    height: '22px',
    '> div': {
      // overflow: 'visible',
      padding: '0px',
      margin: '0px'
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '8px 10px',
    fontSize: '16px',
    color: colors.black
  })
});

// ================== Light variant ================== //

const lightStyles = {
  container: (base) => ({
    ...base,
    paddingTop: '5px'
  }),
  input: () => ({
    height: '22px',
    color: colors.white,
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    textIndent: 0,
    marginLeft: '2px'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '16px',
      color: colors.white
    };
  },
  control: (base) => ({
    ...base,
    borderRadius: 0,
    background: 'transparent',
    border: '0',
    borderBottom: `1px solid ${colors.white}`,
    boxShadow: '0',
    '&:hover': {
      border: '0',
      borderBottom: `1px solid ${colors.white}`
    },
    cursor: 'text',
    outline: 'none',
    minHeight: '22px',
    height: '22px',
    '> div': {
      // overflow: 'visible',
      padding: '0px',
      margin: '0px'
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '8px 10px',
    fontSize: '16px',
    color: colors.black
  })
};

// ================== Block variant ================== //

const blockStyles = {
  container: (base) => ({
    ...base,
    paddingTop: '0px'
  }),
  input: () => ({
    height: '30px',
    color: colors.black,
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    textIndent: 0,
    marginLeft: '5px',
    display: 'flex',
    alignItems: 'center'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '16px',
      color: colors.black
    };
  },
  control: (base) => ({
    ...base,
    background: colors.white,
    borderRadius: '5px',
    border: `0`,
    boxShadow: '0',
    cursor: 'text',
    outline: 'none',
    minHeight: '29px',
    height: '29px',
    '> div': {
      padding: '0px',
      margin: '0px'
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '8px 10px',
    fontSize: '16px',
    color: colors.black
  })
};

// ================== Bordered variant ================== //

const borderedStyles = {
  input: () => ({
    color: colors.black,
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    textIndent: 0,
    display: 'flex',
    alignItems: 'center',
    lineHeight: '24px'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '16px',
      color: colors.black
    };
  },
  valueContainer: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0
  }),
  control: (base) => ({
    ...base,
    border: `1.5px solid ${colors.bluewood200}`,
    borderRadius: '10px',
    boxShadow: 'none',
    cursor: 'text',
    outline: 'none',
    padding: '4.5px 6px 4.5px 12px',
    ':hover': {
      borderColor: colors.bluewood200
    },
    '.single-value': {
      bottom: 'auto',
      left: '8px',
      lineHeight: '24px'
    }
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: 'all .2s ease',
    transform: state.isFocused ? 'rotate(180deg)' : null
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '10px 12px',
    fontSize: '16px',
    color: colors.pickledBluewoodDark2,
    backgroundColor: 'white',
    ':hover': {
      cursor: 'pointer'
    },
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }),
  menu: (base) => ({
    ...base,
    border: `1.5px solid ${colors.bluewood200}`,
    borderRadius: '10px',
    padding: '6px',
    boxShadow: 'none'
  })
};

// ================== Global variant ================== //

const globalStyles = {
  input: () => ({
    margin: 0,
    color: colors.white
  }),
  control: (base) => ({
    ...base,
    borderRadius: '4px',
    background: '#3D505C',
    border: '0.5px solid #5CC6C7',
    boxShadow: '0',
    outline: 'none',
    minHeight: '22px',
    '&:hover': {
      cursor: 'pointer'
    }
  }),
  option: (base) => ({
    ...base,
    background: colors.white,
    color: colors.black,
    '&:active': {
      background: colors.white
    },
    '&:hover': {
      cursor: 'pointer',
      color: colors.turquoise
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  })
};

// ================== Small variant ================== //

const smallStyles = {
  container: (base) => ({
    ...base,
    paddingTop: '0px'
  }),
  input: () => ({
    height: '16px',
    color: colors.white,
    padding: '0px',
    margin: '0px',
    fontSize: '14px',
    textIndent: 0,
    marginLeft: '2px'
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: 0.5,
      fontStyle: 'italic',
      margin: '0px',
      fontSize: '14px',
      color: colors.white
    };
  },
  control: (base) => ({
    ...base,
    borderRadius: 0,
    background: 'transparent',
    border: '0',
    borderBottom: `1px solid ${colors.white}`,
    boxShadow: '0',
    '&:hover': {
      border: '0',
      borderBottom: `1px solid ${colors.white}`
    },
    cursor: 'text',
    outline: 'none',
    minHeight: '16px',
    height: '16px',
    '> div': {
      // overflow: 'visible',
      padding: '0px',
      margin: '0px'
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base) => ({
    ...base,
    padding: '8px',
    fontSize: '14px',
    color: colors.black
  }),
  menu: (base) => ({
    ...base,
    width: '125%'
  })
};

const newRHStyles = {
  container: () => ({
    margin: 0
  }),
  input: (base) => ({
    ...base,
    height: '22px',
    color: colors.white,
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    textIndent: 0,
    marginLeft: '2px'
  }),
  placeholder: (base) => {
    return {
      ...base,
      opacity: 0.5,
      margin: '0px',
      color: colors.white,
      '::after': {
        fontSize: '16px',
        color: colors.red,
        content: '*',
        position: 'absolute'
      }
    };
  },
  control: (base, state) => ({
    ...base,
    border: '0',
    boxShadow: '0',
    outline: 'none',
    minHeight: '22px',
    background: state.menuIsOpen ? colors.indigoDark3 : 'transparent',
    borderRadius: '16px 16px 0px 0px',
    width: '150px',
    padding: '8px 16px',
    '> div': {
      padding: '0px',
      margin: '0px',
      '&:first-child': {
        cursor: 'text'
      },
      '&:last-child': {
        cursor: 'pointer'
      }
    }
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none'
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '12px',
    color: colors.white,
    width: '150px',
    padding: '8px 16px',
    background: state.menuIsOpen ? colors.indigoDark3 : 'transparent',
    '&:hover': {
      background: 'transparent',
      color: 'white',
      cursor: 'pointer'
    }
  }),
  noOptionsMessage: (base) => ({
    ...base,
    width: '150px',
    padding: '8px 16px'
  }),
  menu: () => ({
    position: 'fixed',
    zIndex: 50,
    borderRadius: '0 0 16px 16px',
    background: colors.indigoDark3
  })
};

export const getSelectStyles = (variant, disabled = false, newInputStyle = false) => {
  switch (variant) {
    case 'block':
      return blockStyles;
    case 'light':
      return lightStyles;
    case 'global':
      return globalStyles;
    case 'small':
      return smallStyles;
    case 'newRH':
      return newRHStyles;
    case 'bordered':
      return borderedStyles;
    default:
      return darkStyles(disabled, newInputStyle);
  }
};
